"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderStats = exports.RiderStatsStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Timestamp_1 = require("./Timestamp");
exports.RiderStatsStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    date: Timestamp_1.TimestampStruct,
    deliveryTimeTotal: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    returningTimeTotal: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    onDutyTimeTotal: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    tasksStarted: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    tasksCompleted: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    tasksCancelled: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    tasksFailed: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    tasksReturned: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
function isRiderStats(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.RiderStatsStruct, "RiderStats");
}
exports.isRiderStats = isRiderStats;
